import React from 'react';
import { Link } from 'react-router-dom';
import NavBar from '../components/Navbar/NavBar';

const Hero = () => {
    return (
        <>
            <div className="hero pt-10" id='hero'>
                <div>
                    <NavBar />
                </div>
                <div className="m-auto overflow-hidden mx-4 mt-8 lg:mt-4 p-2 md:p-12 h-5/6" data-aos="zoom-in">
                    <div className="flex flex-col lg:flex-row py-8 justify-between text-center lg:text-left">
                        <div className="lg:w-1/2 flex flex-col justify-center" data-aos="zoom-in" data-aos-delay="200">
                            {/* Badge */}
                            <div className="inline-flex items-center mb-4 self-center lg:self-start">
                                <span className="bg-blue-500 bg-opacity-20 border border-blue-400 border-opacity-40 text-blue-300 text-xs font-bold uppercase tracking-widest px-3 py-1 rounded-full">
                                    New — AT-29384 &nbsp;·&nbsp; Version 5.2
                                </span>
                            </div>
                            <h1 className="mb-5 md:text-5xl text-3xl font-bold text-white leading-tight">
                                Your Car Has Stories.{' '}
                                <span className="text-blue-400">AI ScanWiz Pro</span>{' '}
                                Speaks Its Language.
                            </h1>
                            <div className="text-lg font-medium tracking-tight mb-5 text-gray-300">
                                Plug in. Connect via Bluetooth. Ask your AI anything about your vehicle — in plain English. Real-time OBD2 diagnostics powered by artificial intelligence, in your pocket.
                            </div>
                            {/* Spec pills */}
                            <div className="flex flex-wrap gap-2 mb-6 justify-center lg:justify-start">
                                <span className="bg-blue-900 bg-opacity-60 text-blue-200 text-xs font-semibold px-3 py-1 rounded-full border border-blue-700">Bluetooth 4.0</span>
                                <span className="bg-blue-900 bg-opacity-60 text-blue-200 text-xs font-semibold px-3 py-1 rounded-full border border-blue-700">All 9 OBD2 Protocols</span>
                                <span className="bg-blue-900 bg-opacity-60 text-blue-200 text-xs font-semibold px-3 py-1 rounded-full border border-blue-700">iOS &amp; Android</span>
                                <span className="bg-blue-900 bg-opacity-60 text-blue-200 text-xs font-semibold px-3 py-1 rounded-full border border-blue-700">AI Chat Integration</span>
                                <span className="bg-blue-900 bg-opacity-60 text-blue-200 text-xs font-semibold px-3 py-1 rounded-full border border-blue-700">Universal 12V</span>
                            </div>
                            <div className="mb-4 space-x-0 md:space-x-4 md:mb-8 flex flex-col sm:flex-row gap-3">
                                <Link to="/get-demo" className="text-white bg-blue-600 hover:bg-blue-500 inline-flex items-center justify-center w-full px-6 py-3 text-lg shadow-xl rounded-2xl sm:w-auto">
                                    Order Now
                                    <svg className="w-4 h-4 ml-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
                                </Link>
                                <a href="#about" className="text-blue-300 border border-blue-700 hover:border-blue-400 hover:text-blue-200 inline-flex items-center justify-center w-full px-6 py-3 text-lg rounded-2xl sm:w-auto transition-all duration-200">
                                    Learn More
                                </a>
                            </div>
                        </div>

                        <div className="flex lg:justify-end w-full lg:w-1/2 mt-10 lg:mt-0" data-aos="fade-up" data-aos-delay="500">
                            {/* OBD2 Device Illustration */}
                            <div className="relative w-full flex items-center justify-center">
                                {/* Glow ring */}
                                <div className="absolute w-72 h-72 rounded-full bg-blue-500 opacity-10 blur-3xl"></div>
                                {/* Device card */}
                                <div className="relative ai-pulse bg-gradient-to-b from-gray-800 to-gray-900 border border-gray-600 rounded-3xl p-8 w-64 shadow-2xl">
                                    <div className="text-center mb-4">
                                        <p className="text-gray-400 text-xs font-mono tracking-widest uppercase mb-1">AllyTopic Inc.</p>
                                        <h2 className="text-white text-xl font-bold">AI ScanWiz Pro</h2>
                                        <p className="text-blue-400 text-xs font-mono">AT-29384 · v5.2</p>
                                    </div>
                                    {/* OBD connector visual */}
                                    <div className="bg-gray-700 rounded-lg p-3 mb-4">
                                        <div className="grid grid-cols-8 gap-1 mb-1">
                                            {[1,2,3,4,5,6,7,8].map(n => (
                                                <div key={n} className="w-2 h-3 bg-gray-400 rounded-sm"></div>
                                            ))}
                                        </div>
                                        <div className="grid grid-cols-8 gap-1">
                                            {[9,14,15,16,13,12,11,20].map(n => (
                                                <div key={n} className="w-2 h-3 bg-gray-500 rounded-sm"></div>
                                            ))}
                                        </div>
                                    </div>
                                    {/* Status indicators */}
                                    <div className="flex justify-between items-center mb-3">
                                        <div className="flex items-center gap-1">
                                            <div className="w-2 h-2 rounded-full bg-blue-400 animate-pulse"></div>
                                            <span className="text-blue-300 text-xs">BT 4.0</span>
                                        </div>
                                        <div className="flex items-center gap-1">
                                            <div className="w-2 h-2 rounded-full bg-green-400 animate-pulse"></div>
                                            <span className="text-green-300 text-xs">OBD2 Active</span>
                                        </div>
                                    </div>
                                    {/* AI Chat bubble */}
                                    <div className="bg-blue-900 bg-opacity-60 border border-blue-700 rounded-xl p-3">
                                        <p className="text-blue-200 text-xs font-mono leading-relaxed">
                                            <span className="text-blue-400">AI:</span> Engine temp is 92°C — within normal range. No fault codes detected. ✓
                                        </p>
                                    </div>
                                </div>
                                {/* Floating badge */}
                                <div className="absolute -top-4 -right-4 bg-blue-600 text-white text-xs font-bold px-3 py-1 rounded-full shadow-lg">
                                    AI Powered
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Hero;
